//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "source-stage-log",
  props:['sourceDto'],
  data(){
    return{
      scoreShow:false,
      scoreMenus:[]
    }
  },
  methods:{
    changeShow(stage){
      if(stage.cellShow){
        this.$set(stage,'cellShow',false);
        return;
      }
      this.$set(stage,'cellShow',true);
    },
    viewSupOffer(stage,sup){
      this.$router.push(`/view-offer/${this.sourceDto.id}/${stage.round}/${sup.supplierId}`);
    },
    viewOffer(stage){
      this.$router.push(`/parity-offer/${stage.stageId}`);
    },
    viewScore(item){
      this.scoreMenus = [];
      item.rattingList.forEach((score) => {
        this.scoreMenus.push({label:score.name,scoreItem:score});
      });
      console.log(this.scoreMenus);
      this.scoreShow = true;
    },
    clickMenu(e,item){
      if(item.scoreItem.auditStatus === 'approval'){
        this.$router.push(`/auditing-sup-score/${item.scoreItem.rattingId}/${item.scoreItem.schemeDetailsId}`);
      }else{
        this.$router.push(`/source-score/view/${item.scoreItem.rattingId}`);
      }
    },
    viewPrice(data){
      this.$router.push(`/workflow/${data.workFlowRequsetId}/?component=PriceApprovalViewComponent`);
    },
    viewContract(item){
      this.$router.push(`/contract/${item.followUpId}`);
    }
  }
}



// WEBPACK FOOTER //
// ./src/page/sources/source-common-module/source-stage-log.vue